import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar";
import axiosInstance from "../../api/axiosInstance";

export default function TherapistScheduling() {
  const { state } = useLocation();
  const email = state?.clientEmail || "";
  const [therapistName, setTherapistName] = useState("");
  const [editedMeetingName, setEditedMeetingName] = useState(null);
  const defaultMeetingName = therapistName && state?.clientName
    ? `${therapistName} with ${state.clientName}` : "";
  const meetingName = editedMeetingName ?? defaultMeetingName;
  const [sessionTime, setSessionTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    let active = true;
    axiosInstance.get("/api/therapist/schedule")
      .then(({ data }) => { if (active) setTherapistName(data.therapistName || ""); })
      .catch(() => { /* The meeting name can still be entered manually. */ });
    return () => { active = false; };
  }, []);

  const schedule = async (event) => {
    event.preventDefault();
    if (loading || !email || !meetingName.trim()) return;
    setLoading(true);
    setMessage(null);
    try {
      await axiosInstance.post("/api/therapist/schedule", {
        email: email.trim(), meetingName: meetingName.trim(), sessionTime,
      });
      setMessage({ success: true, text: "Session scheduled successfully." });
    } catch (error) {
      setMessage({ success: false, text: error.response?.data?.message || "Unable to schedule the session. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="max-w-2xl mx-auto px-4 py-10">
        <Link to="/clients" className="text-blue-600 hover:underline">Back to clients</Link>
        <div className="mt-6 bg-white rounded-xl shadow p-6 sm:p-8">
          <h1 className="text-2xl font-semibold text-gray-800">Schedule Session</h1>
          {state?.clientName && <p className="mt-2 text-gray-600">{state.clientName}</p>}
          <form onSubmit={schedule} className="mt-6 space-y-5">
            <label className="block">Client email
              <input type="email" readOnly value={email} className="mt-2 w-full border rounded-md bg-gray-100 p-3" />
              {!email && <p className="mt-2 text-sm text-red-700">Return to the clients list and select a client to schedule.</p>}
            </label>
            <label className="block">Meeting name
              <input required value={meetingName} placeholder="Therapist name with client name" onChange={(e) => setEditedMeetingName(e.target.value)} className="mt-2 w-full border rounded-md p-3" />
            </label>
            <label className="block">Session date and time (Eastern Time)
              <input type="datetime-local" required value={sessionTime} onChange={(e) => setSessionTime(e.target.value)} className="mt-2 w-full border rounded-md p-3" />
            </label>
            {message && <p role={message.success ? "status" : "alert"} className={message.success ? "text-green-700" : "text-red-700"}>{message.text}</p>}
            <button disabled={loading || !email || !meetingName.trim()} className="w-full rounded-md bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white p-3 font-medium">
              {loading ? "Scheduling…" : "Schedule Session"}
            </button>
          </form>
          <Link to="/clients/schedule/link-generator" state={state} className="block mt-6 text-blue-600 hover:underline">Instant Session Link Generator</Link>
        </div>
      </main>
    </div>
  );
}
